import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import * as _ from 'lodash';
import { PortalService } from 'src/services/portal.service';
import * as Chart from 'chart.js';

@Component({
    selector: 'painel-leitos-component',
    templateUrl: 'painel-leitos-component.html',
    styleUrls: ['painel-leitos-component.scss'],
})
export class PainelLeitosComponent implements OnInit {

    // @ViewChild('elSelect', {static: false}) elSelect: ElementRef;

    infoLeitos = [
        {
            total: 12.222,
            poercent: '2,3',
            titulo: 'Leitos convencionais'
        },
        {
            total: 5.555,
            poercent: '21,79',
            titulo: 'Semi-intensivos'
        },
        {
            total: 33,
            poercent: null,
            titulo: 'Leitos de UTI'
        }
    ];

    listAcumulo: any[] = [];
    listCidades: any[] = [];
    listaLeitosTotal: any[] = [];

    datasetsAcumulo: any;
    datasetsLeitosTotal: any;

    constructor(private portal: PortalService) {
    }

    async ngOnInit() {
        this.listCidades = await this.portal.getCDN('PortalMapa');
        console.log('ngOnInit -> PainelGeralComponent');
        this.loadDatas();
    }

    async loadDatas() {
        this.loadAcumulo();
        this.loadLeitosTotal();
    }

    async loadLeitosTotal() {
        this.listaLeitosTotal = [
            {
                label: '24/03',
                qtd_vagos: 200,
                qtd_ocupados: 10,
            },
            {
                label: '25/03',
                qtd_vagos: 200,
                qtd_ocupados: 26,
            },
            {
                label: '26/03',
                qtd_vagos: 200,
                qtd_ocupados: 46,
            },
            {
                label: '27/03',
                qtd_vagos: 200,
                qtd_ocupados: 78,
            },
            {
                label: '28/03',
                qtd_vagos: 200,
                qtd_ocupados: 99,
            },
        ];

        this.datasetsLeitosTotal = {
            labels: _.map(this.listAcumulo, 'label'),
            datasets: [
                {
                    label: 'Ocupados',
                    barThickness: 30,
                    barPercentage: 0.9,
                    categoryPercentage: 0,
                    backgroundColor: '#FAB822',
                    data: [],
                    datalabels: {
                        display: false,
                    },
                },
                {
                    label: 'Vagos',
                    barThickness: 30,
                    barPercentage: 0.9,
                    categoryPercentage: 0,
                    backgroundColor: '#5D78FF',
                    data: [],
                    datalabels: {
                        display: false,
                    },
                },
            ]
        };

        for (let i = 0; i < this.listaLeitosTotal.length; i++) {
            const percent = (Number(this.listaLeitosTotal[i].qtd_ocupados) * 100) / Number(this.listaLeitosTotal[i].qtd_vagos);
            this.datasetsLeitosTotal.datasets[0].data.push(percent);
            this.datasetsLeitosTotal.datasets[1].data.push(100 - percent);
        }
    }

    async loadAcumulo() {
        this.listAcumulo = [
            {
                label: '24/03',
                qtd_vagos: 200,
                qtd_ocupados: 10,
                qtd_uti: 743,
            },
            {
                label: '24/03',
                qtd_vagos: 200,
                qtd_ocupados: 26,
                qtd_uti: 97,
            },
            {
                label: '24/03',
                qtd_vagos: 200,
                qtd_ocupados: 46,
                qtd_uti: 165,
            },
            {
                label: '24/03',
                qtd_vagos: 200,
                qtd_ocupados: 78,
                qtd_uti: 65,
            },
            {
                label: '24/03',
                qtd_vagos: 200,
                qtd_ocupados: 139,
                qtd_uti: 23,
            },
        ];


        this.datasetsAcumulo = {
            labels: _.map(this.listAcumulo, 'label'),
            datasets: [
                {
                    label: 'Convencionais',
                    borderColor: 'rgba(93, 120, 255, 1)',
                    backgroundColor: 'rgba(93, 120, 255, .15)',
                    pointBackgroundColor: 'rgba(93, 120, 255, 1)',
                    data: _.map(this.listAcumulo, 'qtd_vagos'),
                    datalabels: {
                        display: false,
                    },
                },
                {
                    label: 'Semi-intensivos',
                    borderColor: 'rgba(250, 184, 34, 1)',
                    backgroundColor: 'rgba(250, 184, 34, .15)',
                    pointBackgroundColor: 'rgba(250, 184, 34, 1)',
                    data: _.map(this.listAcumulo, 'qtd_ocupados'),
                    datalabels: {
                        display: false,
                    },
                },
                {
                    label: 'UTI',
                    borderColor: 'rgba(251, 57, 122, 1)',
                    backgroundColor: 'rgba(251, 57, 122, .15)',
                    pointBackgroundColor: 'rgba(251, 57, 122, 1)',
                    data: _.map(this.listAcumulo, 'qtd_uti'),
                    datalabels: {
                        display: false,
                    },
                }
            ]
        };
    }
}
